
define('text!templates/modules/member/group/edit/group-edit-content.html',[],function () { return '<div class="panel-body" id="group-edit-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n\n    <div class="alert-list"></div>\n\n    <div id="group-menu"></div>\n\n    <div class="group-edit-form"></div>\n</div>\n';});

